export default class Accordions4i {
    constructor() {
        this.accordionBtns = [];
        this.events = this.events.bind(this);
    }

    async init(container = document){
        this.accordionBtns = Array.from(container.querySelectorAll(".accordionHeader"));

        if (!this.accordionBtns.length) {
            console.warn("No accordion headers found.");
            return;
        }

        container.addEventListener("click", this.events);
    }

    events(e) {
        if(e.target.classList.contains("accordionHeader")){
            e.preventDefault();
            this.toggle(e.target);
        }
    }

    toggle(btn){
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        const panel = this.getPanelElement(btn);
        if (!panel) return;

        isOpen ? this.close(panel) : this.open(panel);
    }

    getPanelElement(btn) {
        return btn.parentNode.nextElementSibling;
    }

    getButtonElement(panel) {
        return panel.previousElementSibling.firstElementChild;
    }

    getPanelHeight(panel){
        panel.style.display = "block";
        const height = panel.scrollHeight + "px";
        panel.removeAttribute("style");
        return height;
    }

    open(panel) {
        const btn = this.getButtonElement(panel);
        const height = this.getPanelHeight(panel);

        panel.style.transition = "height 300ms"; 
        panel.style.height = height;
        panel.classList.add("open");
        panel.setAttribute("aria-hidden", "false");

        if(btn) btn.setAttribute("aria-expanded", "true");

        setTimeout(() => {
            panel.style.transition = "";
            panel.style.height = "";
        }, 300);
    }

    close(panel) {
        const btn = this.getButtonElement(panel);

        panel.style.height = panel.scrollHeight + "px";
        panel.setAttribute("aria-hidden", "true");

        if(btn) btn.setAttribute("aria-expanded", "false");

        setTimeout(() => {
            panel.style.height = "0";
        }, 1);

        setTimeout(() => {
            panel.classList.remove("open")
        }, 300);
    }

    async openAll() {
        const actions = this.accordionBtns.map((btn) => {
            const panel = this.getPanelElement(btn);
            if (panel && !panel.classList.contains("open")) return this.open(panel);
        });
      
        await Promise.all(actions);
    }

    async closeAll() {
        const actions = this.accordionBtns.map((btn) => {
            const panel = this.getPanelElement(btn);
            if (panel && panel.classList.contains("open")) return this.close(panel);
        });
    
        await Promise.all(actions);
    }
}
